export function getPermisos(permisos){  

    //const res = [  'Vehicular', 'Licencias', 'General'] //used for testing
    //return res

    return  JSON.parse(permisos)
}

export function getEmail(email){  

    return  JSON.parse(email)
}

